// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2mOaj","resendInfoText":"OnGoingPaymentBox_resendInfoText__jcAJX"};